import axios from 'axios';
import authHeader from './authHeader';
import { handleError, handleSuccess } from './handleResponse';

const endpointBase = process.env.REACT_APP_API_ENDPOINT || window.location.origin + '/api';
const inFlightGetAllRequests = new Map();

const createService = (endpointPart, multipart) => {
    const baseUrl = endpointBase;
    const legalEntityId = sessionStorage.getItem('filterByLegalEntity');

    const endpoint = baseUrl + '/' + endpointPart

    async function remove(id) {
        const axiosRequestOptions = {
            url: endpoint + '/' + id + '?le=' + legalEntityId,
            method: 'DELETE',
            headers: authHeader()
        };

        return axios(axiosRequestOptions).then(handleSuccess).catch(handleError);
    }

    async function upload(files) {

        const formData = new FormData();
        formData.append("file", files[0]);

        let method = 'POST';

        const axiosRequestOptions = {
            url: endpoint,
            method: method,
            headers: authHeader(),
            data: formData
        };

        return axios(axiosRequestOptions).then(handleSuccess).catch(handleError)

    }

    async function save(data) {
        let method = 'POST';
        let urlId = '';

        if (data.id !== undefined && !multipart) {
            method = 'PUT';
            urlId = '/' + data.id;
        }

        // if (data.id !== undefined && multipart) {
        //     data._method = 'PUT';
        // }

        urlId += '?le=' + legalEntityId

        const axiosRequestOptions = {
            url: endpoint + urlId,
            method: method,
            headers: authHeader(multipart),
            data: data
        };

        return axios(axiosRequestOptions).then(handleSuccess).catch(handleError)

    }

    async function doAction(data) {


        let method = 'POST';
        let urlId = '';


        urlId += '/action';

        const axiosRequestOptions = {
            url: endpoint + urlId,
            method: method,
            headers: authHeader(multipart),
            data: data

        };

        return axios(axiosRequestOptions).then(handleSuccess).catch(handleError)

    }

    async function download(recipe = null, data = null) {

        const axiosRequestOptions = {
            url: endpoint + '/export',
            method: 'GET',
            headers: authHeader(),
            responseType: 'blob'
        };

        if (recipe) {
            axiosRequestOptions.params = {
                recipe: recipe,
                data: data
            }
        }

        return axios(axiosRequestOptions).then(res => {
            // console.log('am i downloading?', res)
            const blob = new Blob([res.data], { type: res.data.type })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            const contentDisposition = res.headers['content-disposition'];

            const fileName = res.headers['content-disposition'].split('filename=')[1]

            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
        }).catch(err => {
            console.log('or do i have an error?', err)
        })
    }

    async function uploadAndDownload(data) {
            console.log('uploadAndDownload: entro', data)
        const axiosRequestOptions = {
            url: endpoint + '/export',
            method:  'POST',
            headers: authHeader(multipart),
            data: data
        };

        return axios(axiosRequestOptions).then(res => {
            console.log('uploadAndDownload: risposta', res)
            const blob = new Blob([res.data], { type: res.data.type })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            const contentDisposition = res.headers['content-disposition'];

            const fileName = res.headers['content-disposition'].split('filename=')[1]

            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
        }).catch(err => {
            console.log('or do i have an error?', err)
        })
    }

    async function getAll(filters = {}, sort = {}, page = '', per_page = '', otherFilters = {}) {
        const requestKey = JSON.stringify({
            endpointPart,
            page,
            per_page,
            filters,
            sort,
            legalEntityId,
            otherFilters
        });

        if (inFlightGetAllRequests.has(requestKey)) {
            return inFlightGetAllRequests.get(requestKey);
        }

        const axiosRequestOptions = {
            url: endpoint,
            method: 'GET',
            headers: authHeader(),
            params: {
                page,
                per_page,
                filters,
                sort,
                le: legalEntityId,
                ...otherFilters
            }
        };

        const requestPromise = axios(axiosRequestOptions).then(handleSuccess).catch(handleError).finally(() => {
            inFlightGetAllRequests.delete(requestKey);
        });

        inFlightGetAllRequests.set(requestKey, requestPromise);
        return requestPromise;
    }

    async function getById(id, params) {

        const axiosRequestOptions = {
            url: endpoint + '/' + id,
            method: 'GET',
            headers: authHeader(),
            params: params
        };

        const res = axios(axiosRequestOptions).then(handleSuccess).catch(handleError);

        return res
    }

    return {
        remove,
        save,
        doAction,
        getAll,
        getById,
        upload,
        download,
        uploadAndDownload
    }
}


export default createService;